import React from "react";
import api from "axios";

import AsyncSelect from "react-select/lib/Async";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const StyledSelect = props => (
  <div style={props.style}>
    <AsyncSelect {...props} />
  </div>
);

class CustomerDetails extends React.Component {
  state = {
    formData: {
      ...this.props.formData
    },
    isSender: this.props.isSender,
    isReciever: this.props.isReciever
  };

  render() {
    return (
      <div>
        <div className="form-row">
          <div className="form-group col-md-3">
            <label className="label">
              Title: <span className="required">*</span>
            </label>
            <input
              id={(this.state.isSender ? "s_" : "") + "title_input"}
              type="text"
              name="title"
              className="form-control"
              value={this.state.formData.title}
              onChange={this.handleinputChange}
              required
            />
          </div>
          <div className="form-group col-md-4">
            <label className="label">
              First Name: <span className="required">*</span>
            </label>
            <input
              id={(this.state.isSender ? "s_" : "") + "firstName_input"}
              type="text"
              name="firstName"
              className="form-control"
              value={this.state.formData.firstName}
              onChange={this.handleinputChange}
              maxLength={35}
              required
            />
          </div>
          <div className="form-group col-md-5">
            <label className="label">
              Last Name: <span className="required">*</span>
            </label>
            <input
              id={(this.state.isSender ? "s_" : "") + "lastName_input"}
              type="text"
              name="lastName"
              className="form-control"
              value={this.state.formData.lastName}
              onChange={this.handleinputChange}
              maxLength={35}
              required
            />
          </div>
        </div>
        {this.multiMembershipFields()}
        {/* {this.dateFields()} */}
        <div className="form-group">
          <label className="label">
            Address: <span className="required">*</span>
          </label>
          <input
            id={(this.state.isSender ? "s_" : "") + "addressLine1_input"}
            type="text"
            name="addressLine1"
            className="form-control"
            value={this.state.formData.addressLine1}
            onChange={this.handleinputChange}
            maxLength={35}
            required
          />
        </div>
        <div className="form-group">
          <label className="label">Address 2:</label>
          <input
            id={(this.state.isSender ? "s_" : "") + "addressLine2_input"}
            type="text"
            name="addressLine2"
            className="form-control"
            value={this.state.formData.addressLine2}
            onChange={this.handleinputChange}
            maxLength={35}
          />
        </div>
        <div className="form-group">
          <label className="label">Address 3:</label>
          <input
            id={(this.state.isSender ? "s_" : "") + "addressLine3_input"}
            type="text"
            name="addressLine3"
            className="form-control"
            value={this.state.formData.addressLine3}
            onChange={this.handleinputChange}
            maxLength={35}
          />
        </div>
        <div className="form-row">
          <div className="form-group col-md-4">
            <label className="label">
              Town / City: <span className="required">*</span>
            </label>
            <input
              id={(this.state.isSender ? "s_" : "") + "town_input"}
              type="text"
              name="town"
              className="form-control"
              value={this.state.formData.town}
              onChange={this.handleinputChange}
              maxLength={35}
              required
            />
          </div>
          <div className="form-group col-md-5">
            <label className="label">
              County / Region: <span className="required">*</span>
            </label>
            <input
              id={(this.state.isSender ? "s_" : "") + "county_input"}
              type="text"
              name="county"
              className="form-control"
              value={this.state.formData.county}
              onChange={this.handleinputChange}
              maxLength={35}
              required
            />
          </div>
          <div className="form-group col-md-3">
            <label className="label">
              Postcode: <span className="required">*</span>
            </label>
            <input
              id={(this.state.isSender ? "s_" : "") + "postcode_input"}
              type="text"
              name="postcode"
              className="form-control"
              value={this.state.formData.postcode}
              onChange={this.handleinputChange}
              maxLength={10}
              required
            />
          </div>
        </div>
        <div className="form-group">
          <label className="label">
            Country: <span className="required">*</span>
          </label>
          <StyledSelect
            cacheOptions
            defaultOptions
            loadOptions={(query, callback) => this.loadCountryOptions(query, callback)}
            value={this.state.formData.country}
            onChange={this.handleCountrySelectChange}
            style={{
              border: this.props.formData.isCountryValid ? "none" : "1px solid #dc3545",
              borderRadius: "4px"
            }}
          />
        </div>
        <div className="form-group">
          <label className="label">
            Phone Number: <span className="required">*</span>
          </label>
          <input
            id={(this.state.isSender ? "s_" : "") + "phone_input"}
            type="text"
            name="phone"
            className="form-control"
            value={this.state.formData.phone}
            onChange={this.handleinputChange}
            maxLength={20}
            required
          />
        </div>
        <div className="form-group">
          <label className="label">
            Email: <span className="required">*</span>
          </label>
          <input
            id={(this.state.isSender ? "s_" : "") + "email_input"}
            type="email"
            name="email"
            className="form-control"
            value={this.state.formData.email}
            onChange={this.handleinputChange}
            maxLength={200}
            required
          />
        </div>
        <hr />
      </div>
    );
  }

  multiMembershipFields = () => {
    if (!this.props.dualMembership || !this.state.isReciever) {
      return;
    }

    return (
      <div className="form-row">
        <div className="form-group col-md-3">
          <label className="label">
            Title: <span className="required">*</span>
          </label>
          <input
            id={(this.state.isSender ? "s_" : "") + "title2_input"}
            type="text"
            name="title2"
            className="form-control"
            value={this.state.formData.title2}
            onChange={this.handleinputChange}
            required
          />
        </div>
        <div className="form-group col-md-4">
          <label className="label">
            First Name: <span className="required">*</span>
          </label>
          <input
            id={(this.state.isSender ? "s_" : "") + "firstName2_input"}
            type="text"
            name="firstName2"
            className="form-control"
            value={this.state.formData.firstName2}
            onChange={this.handleinputChange}
            maxLength={35}
          />
        </div>
        <div className="form-group col-md-5">
          <label className="label">
            Last Name: <span className="required">*</span>
          </label>
          <input
            id={(this.state.isSender ? "s_" : "") + "lastName2_input"}
            type="text"
            name="lastName2"
            className="form-control"
            value={this.state.formData.lastName2}
            onChange={this.handleinputChange}
            maxLength={35}
          />
        </div>
      </div>
    );
  };

  dateFields = () => {
    if (!this.state.isReciever) return;

    return (
      <div className="form-group">
        <label className="label">
          Date of Birth: <span className="required">*</span>
        </label>
        <DatePicker
          selected={this.state.formData.dateOfBirth}
          onChange={this.handleDatePickerChange}
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          dateFormat="DD-MM-YYYY"
          className={this.props.formData.isDateValid ? "form-control" : "form-control input-has-error"}
          required
        />
      </div>
    );
  };

  loadCountryOptions = (query, callback) => {
    var countrySource = "config/countries.json";
    api.get(countrySource).then(response => {
      // Search
      if (query) {
        let options = response.data.filter(i => i.label.toLowerCase().includes(query.toLowerCase()));
        callback(options);
      } else {
        let options = response.data;
        callback(options);

        let formData = this.state.formData;
        formData.country = options[0];

        this.setState({ formData });
      }
    });
  };

  updateFormData = (field, value) => {
    let formData = this.state.formData;
    formData[field] = value;
    this.setState({ formData });

    this.props.detailsChanged(this.state.isSender && !this.state.isReciever ? "sender" : "customer", formData);
  };

  handleinputChange = e => this.updateFormData(e.target.name, e.target.value);
  handleDatePickerChange = date => this.updateFormData("dateOfBirth", date);
  handleCountrySelectChange = e => this.updateFormData("country", e);
}

export default CustomerDetails;



// WEBPACK FOOTER //
// ./src/pages/activate/CustomerDetails.jsx